import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UiNavSection } from '../../models/ui-sidebar.model';

@Component({
  selector: 'app-ui-sidebar',
  templateUrl: './ui-sidebar.component.html',
  styleUrls: ['./ui-sidebar.component.scss']
})
export class UiSidebarComponent {
  @Input() menuSections: UiNavSection[] = [];
  @Input() activePath = '';
  @Input() collapsed = false;
  @Input() logoText = 'PA';
  @Input() companyName = 'Pradhan Associates';
  @Input() appName = 'SupplySync ERP';
  @Output() navigate = new EventEmitter<string>();

  searchTerm = '';

  onSearchChange(term: string): void {
    this.searchTerm = term;
  }

  onNavigate(path: string): void {
    this.navigate.emit(path);
  }
}
